import {
  CurrentSchoolCity,
  CurrentSchoolCountry,
  CurrentSchoolInternationalRegion,
  CurrentSchoolName,
  CurrentSchoolState,
  HighSchoolGraduationYear,
} from "@up/application-fields";

import type { ReactNode } from "react";

export function AcademicInformationPage({
  bottom,
}: {
  bottom: () => ReactNode;
}) {
  return (
    <>
      <HighSchoolGraduationYear />

      <fieldset className="kup-fieldset">
        <legend hidden>Current School</legend>

        <CurrentSchoolName />

        <CurrentSchoolCountry />

        <div className="grid-cols-2 gap-4 md:grid">
          <CurrentSchoolCity />

          <CurrentSchoolState />

          <CurrentSchoolInternationalRegion />
        </div>
      </fieldset>

      {bottom()}
    </>
  );
}
